<template>
  <div class="time-line-box list-box common-shadow">
    <Timeline>
      <TimelineItem color="#AAA" v-for="(vulue, key, index) in timeLineList" :key="index">

        <p class="time">{{key}}</p>
        <div v-for="(i, index) in vulue" :key="index">
          <p class="content">{{i.title}}</p>
          <p class="remarks" v-if="i.note">{{i.note}}</p>
        </div>
      </TimelineItem>
    </Timeline>
  </div>
</template>

<script>
export default {
  props: {
    timeLineList: Object,
  },
};
</script>

<style>
.time-line-box {
  padding: 20px;
}

.time-line-box .time {
  color: #999;
  font-size: 14px;
  padding-bottom: 5px;
}
.time-line-box .content {
  color: #333;
  font-size: 14px;
}
.time-line-box .remarks {
  color: #aaa;
  font-size: 12px;
}
.ivu-timeline-item-head {
  background-color: #aaa;
}
</style>